module.exports = __webpack_public_path__ + "static/media/pulverizador2.ca95b9bc.svg";